// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"177":"home","464":"search","537":"suggestion","845":"profile"}[chunkId] || chunkId) + "." + {"177":"234f553e","373":"0e7ef3cd","464":"f73e94a8","537":"3ed1b331","845":"52bf8482"}[chunkId] + ".css";
};